/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzsgeo6Inputs */

const en__field_enum_mzsgeo6 = /** @type {(inputs: _Field_Enum_Mzsgeo6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geology / geography`)
};

const de__field_enum_mzsgeo6 = /** @type {(inputs: _Field_Enum_Mzsgeo6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geowissenschaften / Geographie`)
};

/**
* | output |
* | --- |
* | "geology / geography" |
*
* @param {_Field_Enum_Mzsgeo6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzsgeo6 = /** @type {((inputs?: _Field_Enum_Mzsgeo6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzsgeo6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzsgeo6(inputs)
	return de__field_enum_mzsgeo6(inputs)
});
export { _field_enum_mzsgeo6 as "_field_enum_MZSGEO" }